// Fan chat and AI credits (pure helpers). With server-side enforcement on, the Fan Agent decides every turn
// (allowed / overage / grace / paused) and the site only needs to know whether the channel owner has a plan.
// Off: the existing browser-side rule (credits > 0 or within the 15-day grace after expiry), unchanged.

export interface AgentVisibility {
  serverEnforcement: boolean;
  hasActivePlan: boolean;
  hasExpiredPlan: boolean;
  credits: number;
  inClientGrace: boolean;
}

export function canShowAgent(v: AgentVisibility): boolean {
  if (v.serverEnforcement) { return v.hasActivePlan || v.hasExpiredPlan; }
  return v.credits > 0 || v.inClientGrace;
}

// The Fan Agent's final reply when the channel owner's AI chat is paused (no model call, no charge).
export function isPausedReply(chunk: any): boolean {
  return !!chunk && chunk.credit_state === 'paused';
}

export function serverEnforcementEnabled(env: any): boolean {
  return !!env && env.CREDIT_SERVER_ENFORCEMENT === true;
}

export const PAUSED_NOTE = 'AI chat is temporarily unavailable for this channel. Please check back later.';
